import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { PaymentGraphModel } from '../projects/_models/payment-graph';
import { queryKeyMap } from '../review-sheet/utils/query-keys';

export const usePaymentGraph = (projectId: string) => {
  return useQuery({
    queryKey: queryKeyMap.paymentGraphData(projectId),
    queryFn: async () => {
      const paymentGraph = await axiosGet(
        `/api/projects/${projectId}/payment-graph-data/`,
      );
      return PaymentGraphModel.parse(paymentGraph);
    },
  });
};
